
import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ComponentsModule } from '../../shared/components/components.module';

@Component({
  selector: 'app-ratgeber-basics-page',
  imports: [
    ComponentsModule
],
  templateUrl: './ratgeber-basics-page.component.html',
  styleUrls: ['./ratgeber-basics-page.component.scss'],
  standalone: true
})
export class RatgeberBasicsPageComponent implements OnInit {
  index = 0;
  content;
  active = new Array(23).fill(true);
  constructor(
    private route: ActivatedRoute,
    private metaTagService: Meta,
    private titleService: Title
  ) {
    this.content = this.route.snapshot.data.content;
    this.titleService.setTitle(this.content.title);
    this.metaTagService.updateTag(
      { name: 'description', content: this.content.description },
      'name=description'
    );
  }

  ngOnInit(): void { }

  toggleActive(index) {
    this.active[index] = !this.active[index];
  }
}
